module.exports = __webpack_public_path__ + "media/customizations/mayfairtxlife/back-62d44e3f9f0dd62be970ebb6e5e5f609.jpg";